import {AfterViewInit, Component, Inject, OnInit, ViewChild, ViewEncapsulation} from '@angular/core';
import {AcDialog, DIALOG_CONFIG} from 'ac-infra';
import * as _ from 'lodash';
import {ChooseTopologyElementFromMapService} from '../../../../utils/choose-topology-item/services/choose-topology-element-from-map/choose-topology-element-from-map.service';
import {NgForm} from '@angular/forms';

const PREFIX_GROUP_NAME_PREFIX = '\u24bc ';

export const ActionCallSetupFields =  [
  { id: 0, value: 'SOURCE_URI_USER'            },
  { id: 1, value: 'SOURCE_URI_HOST'            },
  { id: 2, value: 'DEST_URI_USER'              },
  { id: 3, value: 'DEST_URI_HOST'              },
  { id: 4, value: 'DEST_IP_ADDR'               },
  { id: 5, value: 'DEST_PORT'                  },
  { id: 6, value: 'DEST_PROTOCOL'              },
  { id: 7, value: 'USER_CREDENTIALS_USER_NAME' },
  { id: 8, value: 'USER_CREDENTIALS_PASSWORD'  },
  { id: 9, value: 'P_ASSERTED_IDENTITY_DISPLAY_NAME'  },
  { id: 10, value: 'P_ASSERTED_IDENTITY_USER'  },
  { id: 11, value: 'P_ASSERTED_IDENTITY_HOST'  },
  { id: 12, value: 'TAG_1'  },
  { id: 13, value: 'TAG_2'  },
  { id: 14, value: 'TAG_3'  },
  { id: 17, value: 'INCOMING_CUSTOMER_TAG'  },
  { id: 18, value: 'OUTGOING_CUSTOMER_TAG'  },
  { id: 19, value: 'X_ARM_INFO_1'  },
  { id: 20, value: 'X_ARM_INFO_2'  },
  { id: 21, value: 'X_ARM_INFO_3'  }
];

export const ActionCallSetupFieldsForBlack =  [
  { id: 0, value: 'TAG_1'  },
  { id: 1, value: 'TAG_2'  },
  { id: 2, value: 'TAG_3'  }
];

export const SearchCallSetupFields = [
  { id: 0, value: 'SOURCE_URI_USER'  },
  { id: 1, value: 'SOURCE_URI_HOST'  },
  { id: 2, value: 'DEST_URI_USER'    },
  { id: 3, value: 'DEST_URI_HOST'    },
  { id: 4, value: 'CONTACT_URI_USER' },
  { id: 5, value: 'CONTACT_URI_HOST' },
  { id: 6, value: 'CONTACT_URI_PORT' },
  { id: 7, value: 'P_ASSERTED_IDENTITY_DISPLAY_NAME' },
  { id: 8, value: 'P_ASSERTED_IDENTITY_USER' },
  { id: 9, value: 'P_ASSERTED_IDENTITY_HOST' }
];

export const SearchCredentialsFields = [
  { id: 10, value: 'URI_USER'  },
  { id: 11, value: 'URI_HOST'  }
];

export const ActionCredentialsFields =  [
  { id: 15, value: 'CREDENTIALS'      },
  { id: 16, value: 'DISCARD_CREDENTIALS' }
];

@AcDialog({
  width: 1400,
  height: 730
})
@Component({
  selector: 'policy-studio-dialog',
  templateUrl: './policy-studio-dialog.component.html',
  styleUrls: ['./policy-studio-dialog.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class PolicyStudioDialogComponent implements OnInit, AfterViewInit {

  @ViewChild('ngForm') ngForm: NgForm;
  requestTypeOptions = [{label: 'Call', value: 'CALL'}, {label: 'Register', value: 'REGISTER'}];

  callItem: any;
  policyStudioTypes;
  isEditMode: boolean;
  isNumberPortabilityDisabled: boolean;

  nodesList: any;
  pConsList: any;
  topologyGroupsList: any;
  userGroupGroupsList: any;
  poolNumbersList: any;
  policyStudioRules: any;
  normalizationGroupList: any;
  sipConditionGroups: any;
  sipManipulationGroups: any;

  numberPortabilityList: any;
  prefixGroups: any;
  srcPrefixGroups: any;

  sipHeadersOptions: any;

  matchSelected: any;
  actionSelected: any;
  sipHeaderSelection: any;

  attributeOptionList: any;

  matchSelectOptionList: any;
  matchCredentialsSelectOptionList: any;
  actionSelectOptionList: any;
  blackListActionList: any;
  actionCredentialsSelectedOptionList: any;
  blackListMode: any;
  timeZoneOffset: any;
  dateNow: Date;
  isRowEnabled: boolean[] = [];

  flowSelectedOptionList = [
    {label: 'Stop', value: 'STOP'},
    {label: 'Continue', value: 'CONTINUE'},
    {label: 'Continue to policy studio rule', value: 'CONTINUE_TO_RULE'}
  ];

  directionOptions = [
    { name: 'Outgoing', id: 'OUTGOING' },
    { name: 'Incoming', id: 'INCOMING' }
  ];

  matchByOptions = [
    { name: 'Source and Destination Number', id: 'SRC_AND_DEST' },
    { name: 'Destination', id: 'DEST' },
    { name: 'Source', id: 'SOURCE' }
  ];

  didCountDurationTypeOptions = [
    {value: 'MINUTES', text: 'Clear did count timer from the first hit'},
    {value: 'TIME_OF_DAY', text: 'Clear did count at'}
  ];

  hoursOptions = [
    {text: '00', value: 0}, {text: '01', value: 1}, {text: '02', value: 2},
    {text: '03', value: 3}, {text: '04', value: 4}, {text: '05', value: 5},
    {text: '06', value: 6}, {text: '07', value: 7}, {text: '08', value: 8},
    {text: '09', value: 9}, {text: '10', value: 10}, {text: '11', value: 11},
    {text: '12', value: 12}, {text: '13', value: 13}, {text: '14', value: 14},
    {text: '15', value: 15}, {text: '16', value: 16}, {text: '17', value: 17},
    {text: '18', value: 18}, {text: '19', value: 19}, {text: '20', value: 20},
    {text: '21', value: 21}, {text: '22', value: 22}, {text: '23', value: 23}];

  minutesOptions = [
    {text: '00', value: 0}, {text: '05', value: 5}, {text: '10', value: 10},
    {text: '15', value: 15}, {text: '20', value: 20}, {text: '25', value: 25},
    {text: '30', value: 30}, {text: '35', value: 35}, {text: '40', value: 40}, {text: '45', value: 45},
    {text: '50', value: 50}, {text: '55', value: 55}];



  isInvalidMatchAttributesUser: any;
  isInvalidMatchSipHeadersUser: any;
  isInvalidActionsAttributesUser: any;
  isInvalidSipHeadersPortability: any;
  isInvalidAttributesCredentials: any;
  isInvalidActionsCredentials: any;
  isInvalidMatchAttributesBlacklist: any;
  isInvalidActionsAttributesBlacklist: any;
  isInvalidMatchSipHeadersBlacklist: any;
  isEmptyAttributesForUser: any;

  pConsOptions: any;

  reroutePConsOptions: any;
  nodesDiagramOptions: any;

  constructor(@Inject(DIALOG_CONFIG) private dialogConfig,
              private chooseTopologyElementsFromMapService: ChooseTopologyElementFromMapService) {
    const callItem = this.dialogConfig.dialogData.callItem;
    const selectedRule = this.dialogConfig.dialogData.selectedRule;
    const rules = this.dialogConfig.dialogData.rules;

    this.isEditMode = this.dialogConfig.dialogData.isEditMode;
    this.matchSelectOptionList = SearchCallSetupFields;
    this.matchCredentialsSelectOptionList = SearchCredentialsFields;
    this.actionSelectOptionList = ActionCallSetupFields;
    this.actionCredentialsSelectedOptionList = ActionCredentialsFields;

    const dataObject = this.dialogConfig.dialogData.dataObject;

    this.policyStudioTypes = [{value: 'USER', label: 'User'}];
    if (!this.isNumberPortabilityDisabled) {
      this.policyStudioTypes = [
        {value: 'USER', label: 'User'},
        {value: 'NUMBER_PORTABILITY', label: 'Web Service'},
        {value: 'CREDENTIALS', label: 'Credentials'},
        {value: 'BLACK_LIST', label: 'Blacklist'},
        {value: 'DIDS_COUNT_MATCH', label: 'DIDs Count'}
      ];
    }
    this.blackListMode = [{name : 'Source', id : 'SOURCE'}, {name : 'Destination', id : 'DESTINATION'}];

    this.sipHeadersOptions = [
      {
        value: 'X-MS-UserSite',
        text: 'X-MS-UserSite'
      }, {
        value: 'X-MS-UserLocation',
        text: 'X-MS-UserLocation'
      }
    ];

    this.blackListActionList = ActionCallSetupFieldsForBlack;

    this.initialDialogData(callItem, dataObject);
    this.attributeOptionList = _.cloneDeep(dataObject.attributes);

    dialogConfig.preSubmit = () => {
      this.dialogConfig.dialogData.callItem = this.prepareData();

      return true;
    };

    if (!!selectedRule) {
      this.policyStudioRules = rules.filter(r => r.priority > ((this.isEditMode && selectedRule && selectedRule.oldItem) ?
        selectedRule.oldItem.priority : selectedRule.priority));
    }
    this.setNodesDiagramOptions();
    this.setPConsDiagramOptions();

    if (!this.isEditMode) {
      this.isInvalidMatchAttributesUser = true;
      this.isInvalidActionsAttributesUser = true;
      this.isEmptyAttributesForUser = true;
    }
  }

  updateIsInvalidMatchAttributesUser(): void {
    this.isInvalidMatchAttributesUser = (this.callItem.match.attributes.length > 0) &&
      this.callItem.match.attributes.some(item => (_.isNil(item.values) || item.values.length === 0));

    this.isFormValid();
  }

  updateIsInvalidMatchAttributesBlacklist(): void {
    this.isInvalidMatchAttributesBlacklist = !_.isNil(this.callItem.match.attributes) && this.callItem.match.attributes.some(item =>
        (_.isNil(item.values) || item.values.length === 0)) &&
      !this.callItem.action.attributes.find(action => _.isString(action.values[0]));

    this.isFormValid();
  }

  updateIsInvalidActionsAttributesBlacklist(): void  {
    this.isInvalidActionsAttributesBlacklist = !_.isNil(this.callItem.action.attributes) &&
      this.callItem.action.attributes.some(item => (_.isNil(item.values) || item.values.length === 0));

    this.isFormValid();
  }

  updateIsInvalidMatchSipHeadersBlacklist(): void {
    this.isInvalidMatchSipHeadersBlacklist = !_.isNil(this.callItem.match.sipHeaders) &&
      this.callItem.match.sipHeaders.some(item => _.isNil(item.name) || (_.isNil(item.value) || item.value.length === 0));

    this.isFormValid();
  }

  updateIsInvalidMatchSipHeadersUser(): void {
    this.isInvalidMatchSipHeadersUser = !_.isNil(this.callItem.match.sipHeaders) &&
      this.callItem.match.sipHeaders.some(item => _.isNil(item.name) || (_.isNil(item.value) || item.value.length === 0));

    this.isFormValid();
  }

  updateIsInvalidActionsAttributesUser(): void {
    this.isEmptyAttributesForUser = ((this.callItem.action.attributes.length > 0) &&
      this.callItem.action.attributes.some(item => (_.isNil(item.values) || item.values.length === 0)));

    this.isInvalidActionsAttributesUser = this.isEmptyAttributesForUser ||
      (this.callItem.flow === 'CONTINUE_TO_RULE' && _.isNil(this.callItem.continueToRuleId));

    this.isFormValid();
  }

  updateIsInvalidSipHeadersPortability(): void {
    this.isInvalidSipHeadersPortability = !_.isNil(this.callItem.match.sipHeaders) &&
      this.callItem.match.sipHeaders.some(item => _.isNil(item.name) || (_.isNil(item.value) || item.value.length === 0));

    this.isFormValid();
  }

  updateIsInvalidAttributesCredentials(): void {
    this.isInvalidAttributesCredentials = _.isNil(this.callItem.match.credentials) || this.callItem.match.credentials.length === 0
      || this.callItem.match.credentials.some(item => (_.isNil(item.values) || item.values.length === 0));

    this.isFormValid();
  }

  updateIsInvalidActionsCredentials(): void {
    this.isInvalidActionsCredentials = _.isNil(this.callItem.action.credentials) || this.callItem.action.credentials.length === 0
      || ((_.isNil(this.callItem.action.credentials[0].values) || this.callItem.action.credentials[0].values.length === 0) &&
        this.callItem.action.credentials[0].field !== this.getCredentialsActionFieldId('DISCARD_CREDENTIALS'));

    this.isFormValid();
  }

  ngOnInit(): void {
  }

  ngAfterViewInit(): void {
    this.ngForm.form.statusChanges.subscribe(() => {
      this.isFormValid();
    });
  }

  hasMatchSelection(item): any {
    if (this.matchSelected) {
      return _.isEqual(this.matchSelected.id, item.id) ? 'mark-selected' : '';
    }
    return '';
  }

  selectMatchCallItem(item): void {
    this.matchSelected = item;
  }

  updateMatchSelectOptionList(): void {
    const selectedFields = this.callItem.match.attributes.map(attribute => attribute.field);
    this.matchSelectOptionList = SearchCallSetupFields.filter(item => selectedFields.indexOf(item.id) === -1);
  }

  updateAttributeItemsChange(newValues, item): void {
    item.values = newValues;
  }

  addMatchAttribute(): void {
    this.updateMatchSelectOptionList();
    if (!_.isUndefined(this.callItem)) {
      const newAttr = {
        id: this.generateItemId(this.callItem.match.attributes),
        field: this.matchSelectOptionList[0].id,
        values: []
      };
      this.callItem.match.attributes.push(newAttr);
    }
  }

  removeMatchAttribute(index): void {
    const dataArray = this.callItem.match.attributes;

    this.removeFromArray(dataArray, index);
    this.matchSelected = this.reSelectItem(dataArray, index);

    this.updateMatchSelectOptionList();
/*    if (this.matchSelected) {
      const dataArray = this.callItem.match.attributes;
      const selectedIndex = this.getSelectedIndex(dataArray, this.matchSelected);

      if (selectedIndex !== -1) {
        this.removeFromArray(dataArray, selectedIndex);
        this.matchSelected = this.reSelectItem(dataArray, selectedIndex);
      }
    }
    this.updateMatchSelectOptionList();*/
  }

  addCredentialsMatchAttribute(): void {
    this.updateCredentialsMatchSelectOptionList();
    if (!_.isUndefined(this.callItem)) {
      const newAttr = {
        id: this.generateItemId(this.callItem.match.credentials),
        field: this.matchCredentialsSelectOptionList[0].id,
        values: []
      };
      this.callItem.match.credentials.push(newAttr);
    }
  }

  removeCredentialsMatchAttribute(index): void {
    const dataArray = this.callItem.match.credentials;
    // const selectedIndex = this.getSelectedIndex(dataArray, this.matchSelected);

    this.removeFromArray(dataArray, index);
    this.matchSelected = this.reSelectItem(dataArray, index);
    /*if (this.matchSelected) {
      const dataArray = this.callItem.match.credentials;
      const selectedIndex = this.getSelectedIndex(dataArray, this.matchSelected);

      if (selectedIndex !== -1) {
        this.removeFromArray(dataArray, selectedIndex);
        this.matchSelected = this.reSelectItem(dataArray, selectedIndex);
      }
    }*/
    this.updateCredentialsMatchSelectOptionList();
  }


  getAttributeOptions(options, target): any {
    if (!target) {
      return _.cloneDeep(options);
    }
    const newOptions = _.cloneDeep(options);
    target.forEach(item => {
      const index = newOptions.findIndex(i => i.id === item.id);
      if (index !== -1) {
        newOptions.splice(index, 1);
      }
    });
    return newOptions;
  }

  addActionAttribute(): void {
    this.updateActionSelectOptionList();
    if (!_.isUndefined(this.callItem)) {
      const newAttr = {
        id: this.generateItemId(this.callItem.action.attributes),
        field: this.actionSelectOptionList[0].id,
        values: []
      };
      this.callItem.action.attributes.push(newAttr);
    }
  }

  isActionSelectOptionListEmpty(): boolean {
    return this.actionSelectOptionList.length === 0;
  }

  isActionSelectOptionListBlackListEmpty(): boolean {
    return this.blackListActionList.length === 1;
  }

  removeActionAttribute(index): void {
    const dataArray = this.callItem.action.attributes;
    // const selectedIndex = this.getSelectedIndex(dataArray, this.actionSelected);

    if (index !== -1) {
      this.removeFromArray(dataArray, index);
      this.actionSelected = this.reSelectItem(dataArray, index);
    }
    this.updateActionSelectOptionList();
  }

  hasActionSelection(item): any {
    if (this.actionSelected) {
      return _.isEqual(this.actionSelected.id, item.id) ? 'mark-selected' : '';
    }
    return '';
  }

  selectActionCallItem(item): void {
    this.actionSelected = item;
  }

  updateActionSelectOptionList(): void {
    // save the id number of all the field that already chosen
    const selectedFields = this.callItem.action.attributes.map(attribute => attribute.field);
    // if the id not exist in selected the func return -1
    this.actionSelectOptionList = ActionCallSetupFields.filter(item => selectedFields.indexOf(item.id) === -1);
    this.blackListActionList = ActionCallSetupFieldsForBlack.filter(item => selectedFields.indexOf(item.id) === -1);
  }


  isCredentialsMatchSelectOptionListEmpty(): boolean {
    return this.matchCredentialsSelectOptionList.length === 0;
  }

  updateCredentialsMatchSelectOptionList(): void {
    const selectedFields = this.callItem.match.credentials.map(attribute => attribute.field);
    this.matchCredentialsSelectOptionList = SearchCredentialsFields.filter(item => selectedFields.indexOf(item.id) === -1);
  }

  sipHeaderSelectionHandler(sipHeaderSelectionIndex: number): void {
    this.sipHeaderSelection = sipHeaderSelectionIndex;
  }

  isMatchSelectOptionListEmpty(): boolean {
    return this.matchSelectOptionList.length === 0;
  }

  addSipHeader(): void {
    this.callItem.match.sipHeaders.push({name: '', value: []});
  }

  removeSipHeader(index): void {
    this.callItem.match.sipHeaders.splice(index, 1);
    this.sipHeaderSelection = undefined;
  }

  isHxs1MaskingServiceSelected(): boolean {
    return this.callItem && this.callItem.numberPortability &&
      this.numberPortabilityList.find(item => item.id === this.callItem.numberPortability).type === 'hxs';
  }

  isNpslx1MaskingServiceSelected(): boolean {
    return this.callItem && this.callItem.numberPortability &&
      this.numberPortabilityList.find(item => item.id === this.callItem.numberPortability).type === 'npslx1';
  }

  isNpsb1MaskingServiceSelected(): boolean {
    return this.callItem && this.callItem.numberPortability &&
      this.numberPortabilityList.find(item => item.id === this.callItem.numberPortability).type === 'npsb1';
  }

  isDidMaskingServiceSelected(): boolean {
    return this.callItem && this.callItem.numberPortability &&
      this.numberPortabilityList.find(item => item.id === this.callItem.numberPortability).type === 'did_masking';
  }

  isOnlyUriUserSelected(): boolean {
    return this.callItem && this.callItem.match
      && this.callItem.match.credentials &&
      this.callItem.match.credentials.length === 1;
  }

  isInvalidAttributes(items): boolean {
    return _.isNil(items) || items.length === 0 ||
      items.some(item => item.values.length === 0);
  }

  private generateItemId(dataArray): number {
    const itemsCount = dataArray.length;
    let id = 0;

    for (let i = 0; i < itemsCount; i++) {
      if (id < dataArray[i].id) {
        id = dataArray[i].id;
      }
    }
    return (id + 1);
  }

  private reSelectItem(itemsArray, index): any {
    if (itemsArray[index]) {
      return itemsArray[index];
    } else if (itemsArray[index - 1]) {
      return itemsArray[index - 1];
    } else {
      return false;
    }
  }

  private getSelectedIndex(dataArray, selectedItem): number {
    const itemsCount = dataArray.length;

    for (let i = 0; i < itemsCount; i++) {
      if (_.isEqual(dataArray[i].id, selectedItem.id)) {
        return i;
      }
    }
    return -1;
  }

  private removeFromArray(itemsArray, index): void {
    itemsArray.splice(index, 1);
  }

  private initialDialogData(callItem, dataObject): void {
    this.nodesList = dataObject.nodes;
    this.pConsList = dataObject.pCons;
    this.topologyGroupsList = dataObject.resourceGroups;
    this.userGroupGroupsList = dataObject.userGroups;

    this.numberPortabilityList = [];
    this.callItem = {};
    this.prefixGroups = [];
    this.srcPrefixGroups = [];

    this.numberPortabilityList.push.apply(this.numberPortabilityList, dataObject.numberPortability.filter(item => item.type !== 'custom_http_client'));
    this.poolNumbersList = dataObject.prefixGroups.filter(prefix => (prefix.type === 'NUMBER'));
    this.prefixGroups.push.
    apply(this.prefixGroups, this.extractNamesAndId(dataObject.prefixGroups, 'prefixGroups', PREFIX_GROUP_NAME_PREFIX));
    this.srcPrefixGroups.push.
    apply(this.srcPrefixGroups, this.extractNamesAndId(dataObject.prefixGroups, 'prefixGroups', PREFIX_GROUP_NAME_PREFIX));
    this.normalizationGroupList = dataObject.normalizationGroups;
    this.sipConditionGroups = dataObject.sipConditionGroups;
    this.sipManipulationGroups = dataObject.sipManipulationGroups;
    this.initializeDates();
    this.populateCallItem(callItem, dataObject);
    this.isRowEnabled = this.didCountDurationTypeOptions.map(() => false);
    if (this.callItem.action.block && this.callItem.action.block.didCountDurationType) {
      const index = this.didCountDurationTypeOptions.findIndex(option => option.value === this.callItem.action.block.didCountDurationType);
      this.isRowEnabled[index] = true;
    } else {
      this.isRowEnabled[0] = true;
    }
  }

  private initializeDates(): void {
    this.dateNow = new Date();
    this.timeZoneOffset = this.dateNow.getTimezoneOffset();
  }

  private extractNamesAndId(arrayObject, signature, prefixName): any {
    return arrayObject.map((val) => {
      return {
        listId: signature,
        id: val.id,
        name: prefixName && !val.name.startsWith(prefixName) ? prefixName + val.name : val.name
      };
    });
  }

  private populateCallItem(callItem, dataObject): void {
    if (this.isEmptyObject(callItem)) {
      this.buildFromScratch();
    } else {
      this.restructureParameters(callItem.oldItem, dataObject);
    }
  }

  private isEmptyObject(objectToCheck): boolean {
    for (const prop in objectToCheck) {
      if (objectToCheck.hasOwnProperty(prop)) {
        return false;
      }
    }
    return true;
  }

  private buildFromScratch(): void {
    this.callItem.title = '';
    this.callItem.type = this.policyStudioTypes[0].value;
    this.callItem.adminState = 'LOCKED';
    this.callItem.requestType = 'CALL';
    this.callItem.didMatchType = 'SRC_AND_DEST';
    this.callItem.callExpirationTime = 60;
    this.callItem.direction = 'OUTGOING';

    this.callItem.match = {
      nodeIds: [],
      pConIds: [],
      reroutePconIds: [],
      topologyGroupIds: [],
      prefixGroups: [],
      srcPrefixGroups: [],
      srcUserGroupsIds: [],
      destUserGroupsIds: [],
      attributes: [
        { id: 0, field: SearchCallSetupFields[0].id, values: [] }
      ],
      credentials: [
        { id: 0, field: SearchCredentialsFields[0].id, values: [] }
      ],
      isRegisteredUsers: false,
      sipHeaders: []
    };

    this.callItem.action = {
      attributes: [
        { id: 0, field: ActionCallSetupFields[0].id, values: [] }
      ],
      credentials: [
        { id: 0, field: ActionCredentialsFields[0].id, values: [] }
      ],
      alarm: true,
      tag: undefined,
      sourceOrDestinationNumber: this.blackListMode[0].id,
      whiteAttr: [],
      block: {blockNumberDuration: 60, callOccursMoreThanNumberTimes: 5, callWithinNumberSeconds: 60,
        blockUntilOption: this.didCountDurationTypeOptions[0].value, untilTimeOfDay: {hours: 0, minutes: 0},
      didCountDurationType : 'MINUTES'}
    };
    this.callItem.flow = 'STOP';
  }

  private restructureParameters(callItem, dataObject): void {
    this.callItem.title = callItem.name;
    this.callItem.adminState = callItem.adminState;
    this.callItem.requestType = callItem.requestType;
    this.callItem.type = this.policyStudioTypes.filter((t) => {
      return t.value === callItem.type;
    })[0].value;

    this.callItem.match = {};
    this.buildMatchObject(callItem, dataObject);

    this.callItem.action = {};
    this.buildActionObject(callItem, dataObject);

    this.callItem.numberPortability = this.numberPortabilityList.filter((portability) => {
      return portability.id === callItem.numberPortabilityId;
    })[0];

    if (this.callItem.numberPortability) {
      this.callItem.numberPortability = this.callItem.numberPortability.id;
      this.callItem.poolId = callItem.poolId;
      this.callItem.didMatchType = callItem.didMatchType;
      this.callItem.direction = callItem.direction;
      this.callItem.callExpirationTime = callItem.callExpirationTime ? callItem.callExpirationTime : 60;
      this.callItem.srcNormalizationGroupId = callItem.srcNormalizationGroupId;
      this.callItem.destNormalizationGroupId = callItem.destNormalizationGroupId;
      this.callItem.didXHeader = callItem.didXHeader;
    }

    this.callItem.flow = callItem.flow;
    this.callItem.continueToRuleId = callItem.continueToRuleId;
    this.callItem.sipConditionGroupId = callItem.sipConditionGroupId;
    this.callItem.sipManipulationGroupId = callItem.sipManipulationGroupId;
  }

  private buildMatchObject(callItem, dataObject): void {
    const prefixGroups = this.getObjectsFromIds(callItem.destAttr.attributeGroups, dataObject.prefixGroups);
    let prefixAttrs = [];
    if (_.isArray(callItem.destAttr.attributes)) {
      prefixAttrs = callItem.destAttr.attributes.map((attribute) => {
        return {name: attribute.value, id: attribute.id};
      });
    }

    const srcPrefixGroups = this.getObjectsFromIds(callItem.srcAttr.attributeGroups, dataObject.prefixGroups);
    let srcPrefixAttrs = [];
    if (_.isArray(callItem.srcAttr.attributes)) {
      srcPrefixAttrs = callItem.srcAttr.attributes.map((attribute) => {
        return {name: attribute.value, id: attribute.id};
      });
    }

    this.callItem.match.isRegisteredUsers = callItem.isRegisteredUsers;

    this.callItem.match.nodeIds = callItem.nodeIds;
    this.callItem.match.pConIds = callItem.pConIds;
    this.callItem.match.reroutePconIds = callItem.reroutePconIds;
    this.callItem.match.topologyGroupIds = callItem.topologyGroupIds;
    this.callItem.match.srcUserGroupsIds = callItem.srcUserGroupsIds;
    this.callItem.match.destUserGroupsIds = callItem.destUserGroupsIds;

    this.callItem.match.prefixGroups = [];
    this.callItem.match.srcPrefixGroups = [];
    this.callItem.match.prefixGroups.push
      .apply(this.callItem.match.prefixGroups, this.extractNamesAndId(prefixGroups, 'prefixGroups', PREFIX_GROUP_NAME_PREFIX));
    this.prefixGroups.push.apply(this.prefixGroups, this.extractNamesAndId(prefixAttrs, 'prefix', undefined));
    this.callItem.match.prefixGroups.push.apply(this.callItem.match.prefixGroups, this.extractNamesAndId(prefixAttrs, 'prefix', undefined));

    this.callItem.match.srcPrefixGroups.push
      .apply(this.callItem.match.srcPrefixGroups, this.extractNamesAndId(srcPrefixGroups, 'prefixGroups', PREFIX_GROUP_NAME_PREFIX));
    this.prefixGroups.push.apply(this.srcPrefixGroups, this.extractNamesAndId(srcPrefixAttrs, 'prefix', undefined));
    this.callItem.match.srcPrefixGroups.push.apply(this.callItem.match.srcPrefixGroups,
      this.extractNamesAndId(srcPrefixAttrs, 'prefix', undefined));

    this.callItem.match.attributes = [];
    this.callItem.match.credentials = [];

    if (this.callItem.type === 'NUMBER_PORTABILITY') {
      this.callItem.match.credentials = [
        { id: 0, field: SearchCredentialsFields[0].id, values: [] }
      ];
      this.callItem.match.attributes = [
        { id: 0, field: SearchCallSetupFields[0].id, values: [] }
      ];

      this.callItem.match.sipHeaders = this.sipHeadersInitialization(callItem.sipHeaders);
    } else if (this.callItem.type === 'USER') {
      this.populateAttributes(this.callItem.match.attributes, callItem.searchFields,
        dataObject.attributes, SearchCallSetupFields);
      this.callItem.match.credentials = [
        { id: 0, field: SearchCredentialsFields[0].id, values: [] }
      ];

      this.callItem.match.sipHeaders = this.sipHeadersInitialization(callItem.sipHeaders);
    } else if (this.callItem.type === 'CREDENTIALS') {
      this.populateAttributes(this.callItem.match.credentials, callItem.searchFields,
        dataObject.attributes, SearchCredentialsFields);
      this.callItem.match.attributes = [
        { id: 0, field: SearchCallSetupFields[0].id, values: [] }
      ];
    } else if (this.callItem.type === 'BLACK_LIST') {
      this.populateAttributes(this.callItem.match.attributes, callItem.searchFields,
        dataObject.attributes, SearchCallSetupFields);
      this.callItem.match.credentials = [
        { id: 0, field: SearchCredentialsFields[0].id, values: [] }
      ];

      this.callItem.match.sipHeaders = this.sipHeadersInitialization(callItem.sipHeaders);
    }else if (this.callItem.type === 'DIDS_COUNT_MATCH') {
      this.populateAttributes(this.callItem.match.attributes, callItem.searchFields,
        dataObject.attributes, SearchCallSetupFields);
      this.callItem.match.credentials = [
        { id: 0, field: SearchCredentialsFields[0].id, values: [] }
      ];

      this.callItem.match.sipHeaders = this.sipHeadersInitialization(callItem.sipHeaders);
    }
  }

  private getObjectsFromIds(arrayOfIDs, dataArray): any {
    const result = [];

    if (_.isArray(arrayOfIDs) && arrayOfIDs.length > 0) {
      arrayOfIDs.forEach((id) => {
        const idObject = dataArray.find((item) => {
          return item.id === id;
        });

        if (!_.isUndefined(idObject)) {
          result.push(idObject);
        }
      });
    }
    return result;
  }

  private buildActionObject(callItem, dataObject): void {
    this.callItem.action = {
      attributes: [],
      credentials: []
    };

    if (this.callItem.type === 'NUMBER_PORTABILITY') {
      this.callItem.action.credentials = [
        { id: 0, field: ActionCredentialsFields[0].id, values: [] }
      ];
      this.callItem.action.attributes = [
        { id: 0, field: ActionCallSetupFields[0].id, values: [] }
      ];
    } else if (this.callItem.type === 'USER') {
      this.populateAttributes(this.callItem.action.attributes, callItem.actionFields,
        dataObject.attributes, ActionCallSetupFields);
      this.callItem.action.credentials = [
        { id: 0, field: ActionCredentialsFields[0].id, values: [] }
      ];
    } else if (this.callItem.type === 'CREDENTIALS') {
      this.populateAttributes(this.callItem.action.credentials, callItem.actionFields,
        dataObject.attributes, ActionCredentialsFields);
      this.initializeDiscardCredentialsActions(this.callItem.action.credentials);
      this.callItem.action.attributes = [
        { id: 0, field: ActionCallSetupFields[0].id, values: [] }
      ];
    }
    else if (this.callItem.type === 'BLACK_LIST' || this.callItem.type === 'DIDS_COUNT_MATCH')
    {
      this.populateAttributes(this.callItem.action.attributes, callItem.actionFields,
        dataObject.attributes, ActionCallSetupFieldsForBlack);
      this.callItem.action.sourceOrDestinationNumber = callItem.sourceOrDestinationNumber;
      this.callItem.action.block = {};
      this.callItem.action.block.blockNumberDuration = callItem.blockNumberDuration;
      if (this.callItem.type === 'DIDS_COUNT_MATCH' && callItem.didCountTimeOfDay) {
        let [hour, minute] = callItem.didCountTimeOfDay.split(':');
        hour = parseInt(hour, 10);
        minute = parseInt(minute, 10);
        this.callItem.action.block.untilTimeOfDay = {hours: hour, minutes: minute};
        this.callItem.action.block.didCountDurationType = callItem.didCountDurationType;
      }
      this.callItem.action.block.callOccursMoreThanNumberTimes = callItem.callOccursMoreThanNumberTimes;
      this.callItem.action.block.callWithinNumberSeconds = callItem.callWithinNumberSeconds;
      this.callItem.action.whiteAttr = callItem.whiteAttr;
      this.callItem.action.alarm = callItem.alarmEnabled;

      const prefixGroups = this.getObjectsFromIds(callItem.whiteAttr.attributeGroups, dataObject.prefixGroups);
      let prefixAttrs = [];
      if (_.isArray(callItem.whiteAttr.attributes)) {
        prefixAttrs = callItem.whiteAttr.attributes.map((attribute) => {
          return {name: attribute.value, id: attribute.id};
        });
      }

      this.callItem.action.whiteAttr = [];
      this.callItem.action.whiteAttr.push
        .apply(this.callItem.action.whiteAttr, this.extractNamesAndId(prefixGroups, 'prefixGroups', PREFIX_GROUP_NAME_PREFIX));
      this.prefixGroups.push.apply(this.prefixGroups, this.extractNamesAndId(prefixAttrs, 'prefix', undefined));
      this.callItem.action.whiteAttr.push.apply(this.callItem.action.whiteAttr, this.extractNamesAndId(prefixAttrs, 'prefix', undefined));
    }
  }

  private sipHeadersInitialization(sipHeaders): any {
    if (_.isNil(sipHeaders) || sipHeaders.length === 0) { return []; }

    const sipHeadersData = {};
    const matchSipHeaders = [];

    sipHeaders.forEach(sipHeader => {
      if (_.isNil(sipHeadersData[sipHeader.name])) {
        sipHeadersData[sipHeader.name] = [sipHeader.value];
      } else {
        sipHeadersData[sipHeader.name].push(sipHeader.value);
      }
    });

    for (const [name, value] of Object.entries(sipHeadersData)) {
      matchSipHeaders.push({ name, value });
      if (!this.sipHeadersOptions.find(sipHeader => sipHeader === name)) {
        this.sipHeadersOptions.push(name);
      }
    }

    return matchSipHeaders;
  }

  private populateAttributes(resultArray, sourceArray, dataArray, enumSource): void {
    const attributeCount = sourceArray.length;
    let index = 0;


    for (let i = 0; i < attributeCount; i++) {
      let field = enumSource.find((item) => {
        return item.value === sourceArray[i].field;
      });

      if (field) {
        field = field.id;
      }

      if (sourceArray[i].propertyDicEntryIds !== null) {
        const values = this.getObjectsFromIds(sourceArray[i].propertyDicEntryIds, dataArray);
        resultArray.push({ id: index, field, values });
      } else {
        const sValue = sourceArray[i].sValue;
        const values = [sValue];
        resultArray.push({ id: index, field, values,  sValue});
      }
      index++;
    }
  }

  private initializeDiscardCredentialsActions(actions): any {
    actions.forEach(action => {
      if (action.field === this.getCredentialsActionFieldId('DISCARD_CREDENTIALS')) {
        action.values = [];
      }
    });
  }

  private getCredentialsActionFieldId(actionFieldName: string): any {
    return ActionCredentialsFields.find(action => {
      return action.value === actionFieldName;
    }).id;
  }

  private prepareData(): any {
    let searchFields = [];
    let actionFields = [];

    if (this.callItem.type === 'USER') {
      searchFields = this.getSearchAttributes(this.callItem.match.attributes, SearchCallSetupFields);
      actionFields = [...this.getSearchAttributes(this.callItem.action.attributes, ActionCallSetupFields),
        ...this.getSearchStringAttributes(this.callItem.action.attributes, ActionCallSetupFields)];
    } else if (this.callItem.type === 'CREDENTIALS') {
      searchFields = this.getSearchAttributes(this.callItem.match.credentials, SearchCredentialsFields);
      actionFields = this.getSearchAttributes(this.callItem.action.credentials, ActionCredentialsFields);

      if (actionFields[0] && searchFields[0] &&
        actionFields[0].field === 'DISCARD_CREDENTIALS' &&
        searchFields[0].propertyDicEntryIds) {
        actionFields[0].propertyDicEntryIds = searchFields[0].propertyDicEntryIds;
      }
    }  else if (this.callItem.type === 'BLACK_LIST' || this.callItem.type === 'DIDS_COUNT_MATCH') {
      searchFields = this.getSearchAttributes(this.callItem.match.attributes, SearchCallSetupFields);
      actionFields = [...this.getSearchAttributes(this.callItem.action.attributes, ActionCallSetupFieldsForBlack),
        ...this.getSearchStringAttributes(this.callItem.action.attributes, ActionCallSetupFieldsForBlack)];
    }

    const callItemToServer: any = {
      name: this.callItem.title,
      adminState: this.callItem.adminState,
      nodeIds: this.callItem.match.nodeIds,
      pConIds: this.callItem.match.pConIds,
      reroutePconIds: this.callItem.match.reroutePconIds,
      topologyGroupIds: this.callItem.match.topologyGroupIds,
      srcUserGroupsIds: this.callItem.match.srcUserGroupsIds,
      destUserGroupsIds: this.callItem.match.destUserGroupsIds,
      searchFields,
      actionFields,
      destAttr: this.getPrefixAttributes(this.callItem.match.prefixGroups),
      srcAttr: this.getPrefixAttributes(this.callItem.match.srcPrefixGroups),
      type: this.callItem.type,
      isRegisteredUsers: this.callItem.match.isRegisteredUsers,
    };

    if (this.callItem.type === 'USER') {
      callItemToServer.requestType = this.callItem.requestType;
      callItemToServer.sipHeaders = this.prepareSipHeaderData(this.callItem.match.sipHeaders);
      callItemToServer.sipConditionGroupId = this.callItem.sipConditionGroupId;
      callItemToServer.sipManipulationGroupId = this.callItem.sipManipulationGroupId;
    }

    if (this.isNpsb1MaskingServiceSelected()) {
      callItemToServer.direction = this.callItem.direction;
    }

    if (this.isHxs1MaskingServiceSelected()) {
      callItemToServer.direction = this.callItem.direction;
      callItemToServer.srcNormalizationGroupId = this.callItem.srcNormalizationGroupId;
      callItemToServer.destNormalizationGroupId = this.callItem.destNormalizationGroupId;
    }

    if (this.isNpslx1MaskingServiceSelected()) {
      callItemToServer.srcNormalizationGroupId = this.callItem.srcNormalizationGroupId;
      callItemToServer.destNormalizationGroupId = this.callItem.destNormalizationGroupId;
    }

    if (this.isDidMaskingServiceSelected()) {
      callItemToServer.srcNormalizationGroupId = this.callItem.srcNormalizationGroupId;
      callItemToServer.destNormalizationGroupId = this.callItem.destNormalizationGroupId;
      if (this.callItem.direction === 'OUTGOING') {
        callItemToServer.poolId = this.callItem.poolId;
        callItemToServer.callExpirationTime = this.callItem.callExpirationTime;
        callItemToServer.direction = this.callItem.direction;
      } else {
        callItemToServer.didMatchType = this.callItem.didMatchType;
        callItemToServer.direction = this.callItem.direction;
        callItemToServer.didXHeader = this.callItem.didXHeader;
      }
    }

    if (this.callItem.type === 'NUMBER_PORTABILITY') {
      callItemToServer.numberPortabilityId = this.callItem.numberPortability;
      callItemToServer.sipManipulationGroupId = this.callItem.sipManipulationGroupId;
      callItemToServer.sipHeaders = this.prepareSipHeaderData(this.callItem.match.sipHeaders);
    }

    if (this.callItem.type !== 'CREDENTIALS') {
      callItemToServer.flow = this.callItem.flow;
      if (callItemToServer.flow === 'CONTINUE_TO_RULE') {
        callItemToServer.continueToRuleId = this.callItem.continueToRuleId;
      }
    }

    if (this.callItem.type === 'BLACK_LIST' || this.callItem.type === 'DIDS_COUNT_MATCH') {
      callItemToServer.sourceOrDestinationNumber = this.callItem.action.sourceOrDestinationNumber;
      callItemToServer.callOccursMoreThanNumberTimes = this.callItem.action.block.callOccursMoreThanNumberTimes;
      callItemToServer.blockNumberDuration = this.callItem.action.block.blockNumberDuration;
      // DID
      if (this.callItem.type === 'DIDS_COUNT_MATCH') {
        callItemToServer.didCountTimeOfDay = this.callItem.action.block.untilTimeOfDay.hours + ':' + this.callItem.action.block.untilTimeOfDay.minutes;
        callItemToServer.didCountDurationType = this.callItem.action.block.didCountDurationType;
      }
      // BLACKLIST
      else {
        callItemToServer.didCountTimeOfDay = null;
        callItemToServer.didCountDurationType = null;
        callItemToServer.alarmEnabled = this.callItem.action.alarm;
        callItemToServer.whiteAttr = this.getPrefixAttributes(this.callItem.action.whiteAttr);
        callItemToServer.callWithinNumberSeconds = this.callItem.action.block.callWithinNumberSeconds;
      }

      callItemToServer.sipHeaders = this.prepareSipHeaderData(this.callItem.match.sipHeaders);
    }

    return callItemToServer;
  }

  private getSearchAttributes(dataArray, enumList): any {
    let result = [];
    if (this.isValidArray(dataArray)) {
      dataArray.forEach((item) => {
        if (item.values) {
          const field = this.getEnumValue(item.field, enumList);
          const propertyDicEntryIds = [];
          const valuesCount = item.values.length;
          for (let i = 0; i < valuesCount; i++) {
            if (typeof item.values[i] === 'string' || item.values[i] instanceof String) {
              return;
            } else {
              propertyDicEntryIds.push(item.values[i].id);
            }
          }
          result.push({field, propertyDicEntryIds});
        }
      });
      result = this.mergedAttributesByField(result);
    }
    return result;
  }

  private isValidArray(value): boolean {
    return _.isArray(value) && value.length > 0;
  }

  private getEnumValue(fieldId, enumList): any {
    const fieldEnumData = enumList.find(enumItem => enumItem.id === fieldId);

    return fieldEnumData && fieldEnumData.value ? fieldEnumData.value : fieldId;
  }

  private mergedAttributesByField(attributesArray): any {
    const copyArray = _.cloneDeep(attributesArray);
    const copyArrayLength = copyArray.length;
    const resultObject = {};
    let i;
    const resultArray = [];

    for (i = 0; i < copyArrayLength; i++) {
      if (!(copyArray[i].field in resultObject)) {
        resultObject[copyArray[i].field] = [];
        resultObject[copyArray[i].field].push.apply(resultObject[copyArray[i].field], copyArray[i].propertyDicEntryIds);
      } else {
        resultObject[copyArray[i].field].push.apply(resultObject[copyArray[i].field], copyArray[i].propertyDicEntryIds);
      }
    }

    for (const prop in resultObject) {
      if (resultObject.hasOwnProperty(prop)) {
        resultArray.push({ field: prop, propertyDicEntryIds: resultObject[prop]});
      }
    }

    return resultArray;
  }

  private prepareSipHeaderData(sipHeaders): any {
    if (_.isNil(sipHeaders) || sipHeaders.length === 0) { return []; }

    const sipHeadersData = [];

    sipHeaders.forEach(sipHeader => {
      sipHeader.value.forEach(value => {
        sipHeadersData.push({
          name: sipHeader.name,
          value
        });
      });
    });

    return sipHeadersData;
  }

  private getPrefixAttributes(prefixGroups): any {
    const destPrefix =  { attributes : [], attributeGroups: [] };
    prefixGroups.forEach((prefix) => {
      if (prefix.listId === 'prefixGroups') {
        destPrefix.attributeGroups.push(prefix.id);
      } else {
        destPrefix.attributes.push({value: prefix.name});
      }
    });
    return destPrefix;
  }

  private getSearchStringAttributes(dataArray, enumList): any {
    const result = [];
    if (this.isValidArray(dataArray)) {
      dataArray.forEach((item) => {
        const field = this.getEnumValue(item.field, enumList);
        if (typeof item.values[0] === 'string' || item.values[0] instanceof String) {
          const sValue = item.values[0];
          result.push({field, sValue});
        }
      });
    }
    return result;
  }

  private isFormValid(): void {
    this.dialogConfig.submitButtonDisabled = !this.ngForm.form.valid || this.isUserInvalid() ||
      this.isWebServiceInvalid() || this.isCredentialsInvalid() || this.isBlacklistInvalid();
  }

  private isUserInvalid(): boolean {
    if (this.callItem.type !== 'USER') {
      return false;
    }
    return this.isInvalidMatchAttributesUser || this.isInvalidMatchSipHeadersUser || this.isInvalidActionsAttributesUser;
  }

  private isWebServiceInvalid(): boolean {
    if (this.callItem.type !== 'NUMBER_PORTABILITY') {
      return false;
    }
    return this.isInvalidSipHeadersPortability || !this.callItem.numberPortability ||
      (this.isDidMaskingServiceSelected() && this.callItem.direction === 'OUTGOING' && !this.callItem.poolId);
  }

  private isCredentialsInvalid(): boolean {
    if (this.callItem.type !== 'CREDENTIALS') {
      return false;
    }
    return this.isInvalidAttributesCredentials || this.isInvalidActionsCredentials;
  }

  private isBlacklistInvalid(): boolean {
    if (this.callItem.type !== 'BLACK_LIST') {
      return false;
    }

    return this.isInvalidMatchAttributesBlacklist || this.isInvalidActionsAttributesBlacklist || this.isInvalidMatchSipHeadersBlacklist;
  }

  isSelectionLegal = () => {
    return true;
  }

  setNodesDiagramOptions(): void {
    this.nodesDiagramOptions = this.chooseTopologyElementsFromMapService.prepareOptionsForNodes(this.isSelectionLegal, false,
      this.callItem.match.nodeIds, []);
  }

  setPConsDiagramOptions(): void {
    this.pConsOptions = this.chooseTopologyElementsFromMapService.prepareOptionsForPCons(this.isSelectionLegal, false,
      this.callItem.match.pConIds, []);
  }

  setReroutePConsDiagramOptions(): void {
    this.reroutePConsOptions = this.chooseTopologyElementsFromMapService.prepareOptionsForPCons(this.isSelectionLegal, false,
      this.callItem.match.reroutePconIds, []);
  }

  onNodesDiagramClick($event: any): void {
    this.callItem.match.nodeIds = $event.node.map(nodeItem => nodeItem.dataItem.id);
  }

  onPConsDiagramClick($event: any): void {
    this.callItem.match.pConIds = $event.pCon.filter(item => item.dataItem.peerConnectionNodeType !== 'Virtual')
      .map(pConItem => pConItem.dataItem.id);
  }

  onReroutePConsDiagramClick($event: any): void {
    this.callItem.match.reroutePconIds = $event.pCon.filter(item => item.dataItem.peerConnectionNodeType !== 'Virtual')
      .map(pConItem => pConItem.dataItem.id);
  }


  policyStudioValidation(type): void {
    switch (type) {
      case 'USER':
        this.updateIsInvalidMatchAttributesUser();
        this.updateIsInvalidMatchSipHeadersUser();
        this.updateIsInvalidActionsAttributesUser();
        break;
      case 'NUMBER_PORTABILITY':
        this.updateIsInvalidSipHeadersPortability();
        break;
      case 'CREDENTIALS':
        this.updateIsInvalidAttributesCredentials();
        this.updateIsInvalidActionsCredentials();
        break;
      case 'BLACK_LIST':
        this.updateIsInvalidMatchAttributesBlacklist();
        this.updateIsInvalidActionsAttributesBlacklist();
        this.updateIsInvalidMatchSipHeadersBlacklist();
        break;
    }
  }

  isPoolValid(): void {
    this.isFormValid();
  }

  onRadioChange(option: any, index: number): void {
    this.callItem.action.block.didCountDurationType = option;
    this.isRowEnabled = this.isRowEnabled.map((value, i) => i === index);
  }
}
